export default __webpack_public_path__ + "static/media/Permissions-settings.c99a9aae.png";